export default {
  props: {
    url: String,
    text: String
  }
};